import {Access, DatatableSettings, MapPreferences, UserGroups, Users} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Access: Access,
    public DatatableSettings: DatatableSettings,
    public MapPreferences: MapPreferences,
    public UserGroups: UserGroups,
    public Users: Users,
  ) {}
}